<dashboard-dialog-frame class="mentor-sign-up-add-dialog" header='Add Sign-up' icon="fa-plus" [dialogRef]="dialogRef">

	<div class="d-flex flex-column justify-content-between p-2 h-100">
		<div class="d-flex flex-column gap-2">
			<common-select-field [field]="form.trimester()"></common-select-field>
			<common-select-field [field]="form.language()"></common-select-field>
		</div>

		<div class="mt-3">
			<common-button-row [center]="true">
				<button #formSaveBtn class="btn btn-primary">Save</button>
				<button class="btn btn-standard" (click)="revertValues()">Revert</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Close</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>